import {
  Component,
  ViewChild,
  ElementRef,
  AfterViewInit,
  OnInit,
} from '@angular/core';
import { AuthService } from '../../../services/auth.service';
import { Router } from '@angular/router';
import { ToastService } from '../../../services/toast.service';
import { lastValueFrom } from 'rxjs';
import { MasterService } from '../../../services/policy-allowance-benefits-service/master.service';
import { CommonService } from '../../../services/common/common.service';
import { EmployeeListService } from '../../../services/employee/employee-list.service';
import { CompanyService } from '../../../services/company/company.service';
import { RolesAndPermissionService } from '../../../services/roles-and-permission/roles-and-permission.service';
@Component({
  selector: 'app-otp-verify',
  templateUrl: './otp-verify.component.html',
  styleUrl: './otp-verify.component.scss',
})
export class OtpVerifyComponent implements OnInit, AfterViewInit {
  userId!: number;
  resendDisabled = true;
  timer = 30;
  otpValue = '';
  otpArray: string[] = ['', '', '', '', '', ''];
  currentIndex = 0;

  @ViewChild('hiddenInput')
  hiddenInput!: ElementRef<HTMLInputElement>;

  constructor(
    private readonly authService: AuthService,
    private readonly router: Router,
    private readonly toast: ToastService,
    private readonly employeeService: EmployeeListService,
    private readonly commonService: CommonService,
    private readonly companyService: CompanyService,
    private readonly masterServices: MasterService,
    private readonly permissionService: RolesAndPermissionService,
  ) {
    this.userId = Number(localStorage.getItem('otp_user_id'));
  }

  ngOnInit(): void {
    this.startTimer();
  }

  ngAfterViewInit() {
    setTimeout(() => this.focusHiddenInput(), 0);
  }

  focusHiddenInput() {
    this.hiddenInput.nativeElement.focus();
  }

  onOtpChange(event: Event) {
    const input = event.target as HTMLInputElement;
    const value = input.value.replace(/\D/g, '').slice(0, 6);

    this.otpValue = value;
    this.otpArray = value
      .split('')
      .concat(['', '', '', '', '', ''])
      .slice(0, 6);
    this.currentIndex = Math.min(value.length, 5);

    input.value = value;

    if (this.otpValue.length == 6) {
      this.verifyOtp();
    }
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Backspace' && this.otpValue.length === 0) {
      event.preventDefault();
    }
  }

  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    const paste = event.clipboardData?.getData('text') || '';
    const digits = paste.replace(/\D/g, '').slice(0, 6);

    if (digits) {
      this.hiddenInput.nativeElement.value = digits;
      this.otpValue = digits;
      this.otpArray = digits
        .split('')
        .concat(['', '', '', '', '', ''])
        .slice(0, 6);
      this.currentIndex = Math.min(digits.length, 5);
    }
    if (this.otpValue.length == 6) {
      this.verifyOtp();
    }
  }

  verifyOtp() {
    if (this.otpValue.length !== 6) return;

    this.authService
      .verifyEmailOtp({
        userId: this.userId,
        otp: this.otpValue,
      })
      .subscribe({
        next: async (response: any) => {
          const {
            id,
            employee_login_id,
            name,
            firstname,
            role,
            accessToken,
            client_id,
            status,
            companyID,
            locationID,
            group_id,
            first_login,
            acknowledged,
            icon,
            role_type,
          } = response;

          if (status !== 'Success') {
            const msg =
              status === 'Failure'
                ? 'Company is deactivated. Please contact the admin.'
                : 'Login failed. Please try again.';
            this.toast.failure(msg);
            return;
          }

          const userObj = {
            userID: id,
            employee_login_id,
            name,
            firstname,
            companyID,
            locationID,
            role,
            client: companyID && companyID.length === 0 && role == '2',
            group_id,
            client_id,
            accessToken,
            status,
            first_login,
            acknowledged,
            icon,
            role_type,
          };

          // ✅ Save user and clear old data
          this.authService.updateUser(userObj);
          localStorage.removeItem('default_company');
          this.toast.success('Login Successful');

          const resp: any = await lastValueFrom(
            this.permissionService.getPermission(group_id || 0),
          );

          localStorage.setItem('menus', JSON.stringify(resp.data));
          const userData = JSON.parse(
            localStorage.getItem('auth_user') || '{}',
          );
          if (!userData) return;

          // 🧭 Redirect based on role_type
          if (
            userData.role_type === 'super_admin' ||
            userData.role_type === 'admin' ||
            userData.role_type === 'sub_admin'
          ) {
            console.log('yesss', userData.role_type);

            this.router.navigate(['app/company']);
            return;
          }

          if (
            userData.role_type === 'employee' ||
            userData.role_type === 'super_user'
          ) {
            if (userData.role_type === 'super_user' && !userData.userID) {
              this.router.navigate(['app/company']);
              return;
            }

            // 🧾 Fetch acknowledgement policies
            const resp: any = await lastValueFrom(
              this.masterServices.getAllAcknowledgement(),
            );
            const acknowledgeData = resp?.data ?? [];
            const employeeAcknowledged = userData?.acknowledged ?? [];

            const allAcknowledged = acknowledgeData.every((policy: any) =>
              employeeAcknowledged?.some(
                (emp: any) =>
                  emp?.policy_id === policy.id && emp?.acknowledged === true,
              ),
            );

            if (userData?.first_login == 1) {
              this.router.navigate(['app/employee/employee-dashboard'], {
                queryParams: { firstLogin: userData.first_login },
              });
              return;
            }

            if (!allAcknowledged) {
              this.router.navigate(['app/employee/employee-dashboard'], {
                queryParams: { acknowledge: true },
              });
              return;
            }

            // 📊 Check profile completion
            const empResp: any = await lastValueFrom(
              this.employeeService.getnewEmployee(userData.userID),
            );
            const employeeData = empResp?.data?.employee;

            const percentage = Math.round(
              this.commonService.calculateProfileCompletion(employeeData),
            );

            const companyResp: any = await lastValueFrom(
              this.companyService.getParametersById(userData.companyID),
            );
            const companyPercentage =
              companyResp?.data?.profile_completion_percentage ?? 0;

            if (percentage < companyPercentage) {
              this.router.navigate(
                ['app/employee/list/added/', employeeData.id],
                {
                  queryParams: { lowprofilepercent: true },
                },
              );
            } else {
              this.router.navigate(['app/employee/employee-dashboard']);
            }
          }
        },
        error: (err) => {
          this.toast.failure(err.error.message);
        },
      });
  }

  resendOtp() {
    this.resendDisabled = true;
    this.timer = 30;
    this.otpValue = '';
    this.otpArray = ['', '', '', '', '', ''];
    this.currentIndex = 0;
    this.hiddenInput.nativeElement.value = '';

    this.startTimer();
    this.focusHiddenInput();

    this.authService
      .resendEmailOtp({
        userId: this.userId,
      })
      .subscribe({
        next: (resp: any) => {
          this.toast.success(resp.message);
        },
        error: (error) => {
          this.toast.failure(error.error.message);
        },
      });
  }

  startTimer() {
    const interval = setInterval(() => {
      this.timer--;
      if (this.timer === 0) {
        this.resendDisabled = false;
        clearInterval(interval);
      }
    }, 1000);
  }
}
